import { Button, Card, Col, Form, Result, Row, Space } from 'antd';

import { OptionCard } from '@app/web-components';

import { SupplierPicker } from '../../../../../common';
import { useCreateEdaVendor, useEdaVendorExists } from '../data';

import { useVendorMapForm } from './use-vendor-map-form';

export const CreateForm = () => {
  const create = useCreateEdaVendor();
  const exists = useEdaVendorExists();
  const {
    getCancelButtonProps,
    getCreateAnotherButtonProps,
    getEDAVendorOptionCardProps,
    getErrorFormItemProps,
    getFormProps,
    getProcessesFormItemProps,
    getResetButtonProps,
    getSaveButtonProps,
    getSuccessResultProps,
    getSupplierFormItemProps,
    getT3RequiredOptionCardProps,
  } = useVendorMapForm(create);

  if (create.isSuccess) {
    return (
      <Result
        {...getSuccessResultProps({
          extra: <Button {...getCreateAnotherButtonProps()} />,
        })}
        title="Successfully created EDA or CW Vendor mapping"
      />
    );
  }

  return (
    <Space size="large" style={{ width: '100%' }} wrap>
      <Form {...getFormProps()}>
        {create.error ? <Form.Item {...getErrorFormItemProps()} /> : undefined}
        <Card>
          <Form.Item
            {...getSupplierFormItemProps()}
            required={true}
            rules={[
              { required: true, message: `Supplier is required` },
              {
                message: 'This EDA Vendor already has processes mapped',
                validator: async (_, value) =>
                  (await new Promise((resolve) =>
                    exists.mutate(parseInt(value.value), {
                      onSuccess: (data) => {
                        resolve(data);
                      },
                    }),
                  ))
                    ? Promise.reject()
                    : Promise.resolve(),
              },
            ]}
          >
            <SupplierPicker.Select placeholder="Supplier to map processes to" />
          </Form.Item>
          <Form.Item {...getProcessesFormItemProps()} />
          <Row gutter={20} style={{ marginBottom: 30 }}>
            <Col span={6}>
              <OptionCard {...getEDAVendorOptionCardProps()} />
            </Col>
            <Col span={6}>
              <OptionCard {...getT3RequiredOptionCardProps()} />
            </Col>
          </Row>
          <Space style={{ marginTop: 20 }}>
            <Button {...getSaveButtonProps()} />
            <Button {...getResetButtonProps()} />
            <Button {...getCancelButtonProps()} />
          </Space>
        </Card>
      </Form>
    </Space>
  );
};
